import { createContext, useContext, useEffect, useState } from "react";
import api from "../api";

const SiteContext = createContext({ site: null, stats: null, features: [], faqs: [] });

export function SiteProvider({ children }) {
  const [data, setData] = useState({ site: null, stats: null, features: [], faqs: [], plans: [] });

  useEffect(() => {
    api.get("/public/bootstrap")
      .then((res) => setData({
        site: res.data.settings,
        stats: res.data.stats,
        statsLiveAt: res.data.stats_live_at || null,
        botOnline: !!res.data.bot_online,
        features: Array.isArray(res.data.features) ? res.data.features : [],
        faqs: Array.isArray(res.data.faqs) ? res.data.faqs : [],
        plans: res.data.premium_plans || [],
      }))
      .catch(() => {});
  }, []);

  return <SiteContext.Provider value={data}>{children}</SiteContext.Provider>;
}

export function useSite() {
  return useContext(SiteContext);
}
